<template>
  <home-base-card
    card_title="テンプレート管理"
    :link_path="link_path"
    icon="mdi-clipboard-list-outline"
    :loading="loadingFlg"
    :set_color="templateCount > 0 ? 'bg_ok' : 'bg_ng'"
    :is_error="isError"
  >
    <div>
      <span class="text-h5 text-blue mr-1">{{ templateCount }}</span
      >件 登録されています
    </div>
  </home-base-card>
</template>
<script>
import { reactive, toRefs, onMounted } from "@vue/composition-api";
import store from "@/store/index.js";
import { repositoryFactory } from "@/repository/repositoryFactory";
import setting from "@/common/setting.js";
import retryRequest from "@/common/retryRequest";

export default {
  props: ["link_path"],
  setup(props, ctx) {
    const TemplateRepository = repositoryFactory.get("templates");
    const state = reactive({
      loadingFlg: false,
      templateCount: 0,
      isError: false,
    });

    const getTemplateList = async () => {
      state.isError = false;
      state.loadingFlg = true;

      try {
        const response = await retryRequest(
          TemplateRepository.list,
          store.getters["shops/currentShop"].id
        );
        if (response.data) {
          state.templateCount = response.data.length;
        }
      } catch (error) {
        state.isError = true;
      } finally {
        state.loadingFlg = false;
      }
    };

    onMounted(() => {
      getTemplateList();
    });

    return {
      props,
      ...toRefs(state),
    };
  },
};
</script>
